import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {Link} from 'shells/link/link';
import {PopoverInfo} from 'shells/popover-info/popover-info';

import styles from './admin-popover-info.module.css';

export function AdminPopoverInfo() {
    return (
        <div className={styles['admin-popover-info']}>
            <PopoverInfo
                size={15}
                info={
                    <div>
                        <div className='mb-8'>
                            You should know that giving admin access includes the ability to:{' '}
                        </div>
                        <BulletedList
                            size='small'
                            bullets={[
                                'Change your account’s billing',
                                'View and export all data in your account',
                                'Grant and revoke admin access and user status',
                                'Change all company-wide account settings',
                                'Change other user’s pass words',
                                <span key='more-info'>
                                    For more information click{' '}
                                    <Link
                                        href='https://support.nutshell.com/en/articles/8428893-users-teams-customizing-nutshell-user-access'
                                        // @ts-expect-error
                                        target='_blank'
                                        variant='primary'
                                        size='small'
                                    >
                                        here
                                    </Link>
                                    .
                                </span>,
                            ]}
                        />
                    </div>
                }
            />
        </div>
    );
}
